<template>
    <span
        v-if="status.value"
        class="accordion-toggle__complete"
    >
        <span class="d-none d-lg-inline-block mr-3">
            Section Complete
        </span>
        <SVGSprite
            name="checked"
            class="accordion-toggle__complete-icon"
        />
    </span>
    <span
        v-else
        class="accordion-toggle__error"
    >
        <span class="d-none d-lg-inline-block mr-3">
            Section Incomplete
        </span>
        <SVGSprite
            name="warning"
            class="accordion-toggle__error-icon"
        />
    </span>
</template>

<script>
export default {
    name: 'ValidationCheck',
    props: {
        status: {
            type: Object,
            required: true
        }
    }
};
</script>

<style lang="scss">

</style>
